import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "event_available",
    title: "Flexible Scheduling",
    description:
      "We work around guest check-in and check-out times to ensure seamless turnarounds.",
  },
  {
    icon: "star_rate",
    title: "Guest-Ready Standards",
    description:
      "Every clean is carried out to a consistent standard that meets guest expectations.",
  },
  {
    icon: "inventory_2",
    title: "Linen & Supplies",
    description: "We can manage linen changeovers and replenishment of guest supplies on request.",
  },
  {
    icon: "verified",
    title: "Quality Checked",
    description: "Each visit is quality-checked to ensure nothing is missed before guests arrive.",
  },
];

function Accommodation_Section3() {
  return <ServiceHighlights items={items} />;
}

export default Accommodation_Section3;
